import React from 'react';
import {
  Card,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup
} from '@material-ui/core';
import { Business as BusinessIcon } from '@material-ui/icons';

import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import { InlineFormControl } from '../../../common/inline/InlineFormControl';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import { BaseSignupCardProps } from '../../../login/Signup.interface';
import { industries } from '../../../onboarding/OnboadingCompanyInfo';

const SignupCompanyInfoCard: React.FC<BaseSignupCardProps> = props => {
  const { signup } = props;
  return (
    <Card>
      <CardTitle>
        <BusinessIcon />
        Company Info
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik initialValues={{}} onSubmit={() => {}}>
          <InlineForm>
            <InlineTextField
              name='companyName'
              label='Company Name'
              value={signup.companyName || ''}
              inputProps={{ readOnly: true }}
            />
            <InlineFormControl label='What industries are you focused on?'>
              <FormGroup>
                {industries.map(industry => (
                  <FormControlLabel
                    key={industry}
                    label={industry}
                    control={
                      <Checkbox
                        readOnly
                        color='primary'
                        checked={signup.industries.includes(industry)}
                      />
                    }
                  />
                ))}
              </FormGroup>
            </InlineFormControl>
            <InlineFormControl label='Do you have an existing Quality Management System (QMS)?'>
              <RadioGroup row value={signup.hasExistingQms}>
                <YesOrNoField />
              </RadioGroup>
            </InlineFormControl>
            {signup.hasExistingQms && (
              <>
                <InlineTextField
                  name='existingQmsInfo'
                  label='What QMS are you currently using?'
                  value={signup.existingQmsInfo || ''}
                  inputProps={{ readOnly: true }}
                />
                <InlineFormControl label='Do you need help migrating data from your existing QMS?'>
                  <RadioGroup row value={signup.migrateExistingQms}>
                    <YesOrNoField />
                  </RadioGroup>
                </InlineFormControl>
              </>
            )}
            <InlineFormControl label='Do you already have policies and procedures defined?'>
              <RadioGroup row value={signup.hasPolicies}>
                <YesOrNoField />
              </RadioGroup>
            </InlineFormControl>
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default SignupCompanyInfoCard;

const YesOrNoField: React.FC = () => {
  return (
    <>
      {[
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ].map((option, index) => (
        <FormControlLabel
          key={index}
          value={option.value}
          label={option.label}
          control={<Radio readOnly color='primary' />}
        />
      ))}
    </>
  );
};
